/* ============================================================================
   The app-wide upload bar. Any file going up through uploadFile() reports its
   real byte progress to the bus in lib/files; this floats bottom-right while
   anything is in flight and gets out of the way three seconds after the last
   file lands. The cure for "it just says Saving" — moving and stuck now look
   different.
   ========================================================================== */
import { useUploads } from "../lib/files";
import { Icon } from "./Icons";
import { t } from "../lib/i18n";

const mb = (b: number) => (b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} MB` : `${Math.round(b / 1024)} KB`);

export function UploadOverlay() {
  const uploads = useUploads();
  if (!uploads.length) return null;
  return (
    <div style={{
      position: "fixed", right: 16, bottom: 16, zIndex: 200, width: "min(340px, calc(100vw - 32px))",
      background: "var(--card)", border: "1px solid var(--line)", borderRadius: 14,
      boxShadow: "0 18px 50px -12px rgba(0,0,0,.35)", padding: "12px 14px",
    }}>
      <div className="kicker" style={{ fontSize: 8.5, marginBottom: 8 }}>
        {uploads.some((u) => !u.doneAt) ? t("Uploading") : t("Uploaded")}
      </div>
      <div className="col" style={{ gap: 9 }}>
        {uploads.map((u) => (
          <div key={u.key}>
            <div className="row between" style={{ gap: 10, marginBottom: 4 }}>
              <span className="row" style={{ gap: 6, minWidth: 0, alignItems: "center" }}>
                {u.doneAt
                  ? <Icon.checkCircle width={12} style={{ color: "var(--ok)", flexShrink: 0 }} />
                  : <Icon.upload width={12} style={{ color: "var(--accent)", flexShrink: 0 }} />}
                <span style={{ fontSize: 11.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.name}</span>
              </span>
              <span className="mono dim" style={{ fontSize: 10.5, flexShrink: 0 }}>
                {u.doneAt ? mb(u.bytes) : `${u.pct}%`}
              </span>
            </div>
            <div style={{ height: 4, borderRadius: 4, background: "var(--line)", overflow: "hidden" }}>
              <div style={{
                height: "100%", width: `${u.pct}%`,
                background: u.doneAt ? "var(--ok)" : "var(--accent)",
                transition: "width .25s ease",
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
